import styled from "styled-components";

export const HeaderDescription = styled.p`
  font-size: 18px;
  margin: 12px 35px;

  @media print {
    margin-bottom: 16px;
  }
`;

export const BlueHeader = styled.p`
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.5px;
  background-color: ${props => props.theme.primaryXLight};
  color: ${props => props.theme.black};
  padding: 8px 35px;
  margin: 0;
`;

export const OpportunityBackground = styled.p`
  font-size: 16px;
  line-height: 20px;
  margin: 16px 35px;
`;

export const ActionPlans = styled.div`
  font-size: 16px;
  margin: -4px 31px;
  display: flex;
  flex-wrap: ${props => (props.landscape ? 'nowrap' : 'wrap')};
  @media print {
    max-width: 995px !important;
  }
`;

export const ActionPlan = styled.div`
  font-size: 16px;
  margin: 4px;
  background: ${props => props.theme.light};
  flex-grow: ${props => (props.landscape ? '1' : '0')};
  flex-basis: ${props => (props.landscape ? '0' : '48%')};

  p.action-plan-title {
    font-weight: 600;
    background: ${props => props.theme.tertiary};
    margin: 0;
  }

  p {
    padding: 4px 8px;
    line-height: 20px;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/ActionPlanning/style.js